module.exports = __webpack_public_path__ + "media/images/regions/thumbnails/europe_and_central_asia-a16bc78709dbd735ad2151d4219c3da3.png";